let myLatLng = { lat: 41.0082, lng: 28.9784 };

iziToast.settings({
    timeout: 5000,
    resetOnHover: true,
    position: 'topRight',
});
var $locationAlert = 'الرجاء اختيار الموقع بشكل صحيح ',
    $time = 'الوقت المتوقع: ',
    $length = 'طول المسافة: ',
    $mins = ' دقيقة',
    $km = ' كم',
    $errorEmailMsg = 'عنوان البريد الذي أدخلته غير صحيح!',
    $pleaseEnterNameMsg = 'الرجاء ادخال الاسم',
    $pleaseEnterPassportNumber = 'الرجاء إدخال رقم جواز السفر',
    $pleaseEnterNameEmail = 'الرجاء ادخال البريد الالكتروني',
    $pleaseEnterMobileMsg = 'الرجاء ادخال رقم الهاتف',
    $pleaseEnterNumberOnly = 'رقم الهاتف يجب ان يكون ارقام فقط',
    $pleaseEnterValidMobileMsg = 'رقم الهاتف يجب أن يكون أكبر من 5 أرقام',
    $TooManyAttempts = 'عدد كبير جداً من الطلبات، يرجى المحاولة مرة أخرى بعد 30 ثانية',
    $errorSending = 'حدث خطأ ما , يرجى المحاولة لاحقا',
    $policyValidation = 'الرجاء الموافقة على الشروط والأحكام',
    $forbidden = 'هذا الايميل مسجل مسبقا',
    $pleaseEnterTime = 'الرجاء ادخال الوقت',
    $pleaseEnterDate = 'الرجاء ادخال اتاريخ',
    $pleaseEnterReturnDate = 'الرجاء إدخال تاريخ العودة بشكل صحيح',
    $pleaseEnterReturnTime = 'الرجاء إدخال وقت العودة بشكل صحيح',
    $daysCount = 'عدد الأيام',
    $please_check_terms_and_conditions = 'الرجاء الموافقة على الشروط والأحكام',
    $please_enter_cardholdername = 'الرجاء إدخال اسم حامل البطاقة بشكل صحيح.',
    $please_enter_cardnumber = 'الرجاء إدخال رقم البطاقة بشكل صحيح.',
    $please_enter_expirydate = 'الرجاء إدخال تاريخ انتهاء الصلاحية بشكل صحيح.',
    $please_enter_cvv = 'الرجاء إدخال رمز CVV بشكل صحيح.',
    $please_review_paymentinfo = 'الرجاء التحقق من معلومات الدفع قبل المتابعة.',
    $payment_successful = 'عملية الدفع تمت بنجاح.',
    $apply = 'تطبيق',
    $cancel = 'إلغاء',
    $chair = 'كرسي',
    $bags = 'حقائب',
    $iAgree = 'اوافق على',
    $currentLocation = "الموقع الحالي",
    $chooseDistanceMsg = "الرجاء اختيار مسافة أكبر من 1 كم",
    $newOrderQuestion = "هل تريد إلغاء الطلب وإنشاء طلب جديد؟";
$monthes = [
    'كانون 2',
    'شباط',
    'آذار',
    'نيسان',
    'أيار',
    'حزيران',
    'تموز',
    'آب',
    'أيلول',
    'تشرين 1',
    'تشرين 2',
    'كانون 1',
];
$daysOfWeek = [
    "أحد",
    "إثن",
    "ثلا",
    "ارب",
    "خم",
    "جم",
    "سبت"
];

var messagesArray = [];
messagesArray["Giriş yaptığınız işlem tipi için zorunlu alanları kontrol ediniz"] = "تحقق من الحقول الإلزامية لنوع العملية التي قمت بتسجيل الدخول لها";
messagesArray["Hatali para birimi"] = "عملة غير صحيحة";
messagesArray["Aynı sipariş içinde sadece bir tane satış işlemi yapılabilir"] = "يمكن إجراء عملية بيع واحدة فقط  لنفس الطلب";
messagesArray["TxnAmount field must not be zero DOUBLE value because of the Mandatory Rule:zero"] = "يجب ألا يكون حقل TxnAmount قيمته صفرية لقاعدة الإلزام: الصفر";
messagesArray["Yurtici kartlar YP islem yapamaz"] = "لا يمكن لبطاقات YP الداخلية إجراء عمليات";
messagesArray["SON KULLANMA TARIHI HATALI"] = "تاريخ انتهاء الصلاحية غير صحيح";
messagesArray["Sadece şifreli işlem yapılmasına izin verilmektedir"] = "يُسمح فقط بإجراء عمليات مشفرة";
messagesArray["YURTICI ALISVERIS LIMITI ASIMI"] = "تم تجاوز حد الشراء الداخلي";
messagesArray["Giriş yaptığınız değerleri kontrol ediniz"] = "تحقق من القيم التي قمت بتسجيل الدخول لها";
messagesArray["CardNumber field must contain a valid card number"] = "يجب أن يحتوي حقل CardNumber على رقم بطاقة صالح";
messagesArray["Unidentified Card Number"] = "رقم بطاقة غير معروف";
messagesArray["Hesap musait degil."] = "الحساب لا يحتوي على المبلغ المطلوب";
messagesArray["Islem Onaylanmadi."] = "العملية لم يتم الموافقة عليها";
messagesArray["User Gave Up"] = "المستخدم تخلى عن العملية";
messagesArray["CVC2/4CSC HATALI,MAX SAYI ASTI"] = "CVC2/4CSC غير صحيح، تجاوز الحد الأقصى للعدد";
messagesArray["Vadesi Dolmus Kart."] = "بطاقة منتهية الصلاحية";
messagesArray["ISLEM ONAYLANMADI"] = "العملية غير موافق عليها";
messagesArray["ECOMMERCE ISLEM LIMITI ASILIYO"] = "تم تجاوز حد العمليات التجارية عبر الإنترنت";
messagesArray["SON KULLANMA TARIHI GECMIS"] = "انتهت صلاحية البطاقة";
messagesArray["İşleminizi gerçekleştiremiyoruz.Tekrar deneyiniz"] = "الرجاء المحاولة مرة أخرى، حدث خطأ غير متوقع ";
messagesArray["ErrorId: 0651"] = "خطأ: 0651 ";
messagesArray["ErrorId: 0104"] = "خطأ: 0104 ";
messagesArray["ErrorId: 0800"] = "خطأ: 0800 ";
messagesArray["ErrorId: 0752"] = "خطأ: 0752 ";
messagesArray["ErrorId: 0116"] = "خطأ: 0116 ";
messagesArray["Invalid account number (no such number)"] = "رقم الحساب خطأ ";
messagesArray["ISLEM ONAYLANMADI"] = "العملية لم يتم الموافقة عليها";
messagesArray["Invalid security code"] = "الرقم السري غير صحيح";
messagesArray["Undefined terminal"] = "رقم الحساب غير صحيح";

var $Language = $("html").attr("lang");
if ($Language === 'en') {
    $locationAlert = 'Please choose the correct location';
    $time = 'Expected Time: ';
    $length = 'Distance : ';
    $mins = ' min';
    $km = ' KM';
    $choiceCountyCode = 'Please Enter Country Code';
    $errorEmailMsg = 'Invalid Email';
    $pleaseEnterNameMsg = 'Please Enter Name';
    $pleaseEnterMobileMsg = 'Please Enter Mobile Number';
    $pleaseEnterNumberOnly = 'Phone number must be numbers only';
    $pleaseEnterValidMobileMsg = 'Phone number must include more than 5 numbers';
    $TooManyAttempts = 'Too many attempts, please slow down the request.';
    $errorSending = 'There was an error while sending the message, Please try again later.';
    $forbidden = 'The email field has already been taken';
    $policyValidation = 'Please accept Terms and Policies';
    $pleaseEnterNameEmail = 'Please Enter Email';
    $pleaseEnterTime = 'Please enter the time.';
    $pleaseEnterDate = 'Please enter the date.';
    $pleaseEnterReturnDate = 'Please enter a valid return date';
    $pleaseEnterReturnTime = 'Please enter a valid return time';
    $daysCount = 'Number of days';
    $pleaseEnterDate = 'Payment has been successfully completed';
    $please_check_terms_and_conditions = 'Please accept the terms and conditions';
    $pleaseEnterPassportNumber = 'Please enter the passport number';
    $please_enter_cardholdername = 'Please enter the card holder\'s name correctly.';
    $please_enter_cardnumber = 'Please enter the card number correctly.';
    $please_enter_expirydate = 'Please enter the expiration date correctly.';
    $please_enter_cvv = 'Please enter the CVV code correctly.';
    $please_review_paymentinfo = 'Please review the payment information before proceeding.';
    $payment_successful = 'Payment successful.';
    $apply = 'Apply';
    $cancel = 'Cancel';
    $chair = 'Chair';
    $bags = 'Bags';
    $iAgree = 'i agree';
    $currentLocation = 'Current location';
    $chooseDistanceMsg = 'Please choose a distance greater than 1 km';
    $newOrderQuestion = "Do you want to cancel the order and create a new one?";
    $monthes = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    $daysOfWeek = [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ];
    var messagesArray = {
        "Giriş yaptığınız işlem tipi için zorunlu alanları kontrol ediniz": "Please check the required fields for the transaction type you have logged in for.",
        "Hatali para birimi": "Invalid currency.",
        "Aynı sipariş içinde sadece bir tane satış işlemi yapılabilir": "Only one sale transaction can be performed for the same order.",
        "TxnAmount field must not be zero DOUBLE value because of the Mandatory Rule:zero": "The TxnAmount field must not be zero DOUBLE value because of the Mandatory Rule:zero.",
        "Yurtici kartlar YP islem yapamaz": "Domestic cards cannot perform YP transactions.",
        "SON KULLANMA TARIHI HATALI": "Expiration date is invalid.",
        "Sadece şifreli işlem yapılmasına izin verilmektedir": "Only encrypted transactions are allowed.",
        "YURTICI ALISVERIS LIMITI ASIMI": "Domestic shopping limit exceeded.",
        "Giriş yaptığınız değerleri kontrol ediniz": "Please check the values you have logged in for.",
        "CardNumber field must contain a valid card number": "The CardNumber field must contain a valid card number.",
        "Unidentified Card Number": "Unidentified card number.",
        "Hesap musait degil.": "Account does not have the required amount.",
        "Islem Onaylanmadi.": "Transaction not approved.",
        "User Gave Up": "User gave up the transaction.",
        "CVC2/4CSC HATALI,MAX SAYI ASTI": "CVC2/4CSC is invalid, maximum number exceeded.",
        "Vadesi Dolmus Kart.": "Expired card.",
        "ISLEM ONAYLANMADI": "Transaction not approved.",
        "ECOMMERCE ISLEM LIMITI ASILIYO": "E-commerce transaction limit exceeded.",
        "SON KULLANMA TARIHI GECMIS": "Card is expired.",
        "İşleminizi gerçekleştiremiyoruz.Tekrar deneyiniz": "We cannot process your transaction. Please try again.",
        "ErrorId: 0651": "Error: 0651.",
        "ErrorId: 0104": "Error: 0104.",
        "ErrorId: 0800": "Error: 0800.",
        "ErrorId: 0752": "Error: 0752.",
        "ErrorId: 0116": "Error: 0116.",
        "Invalid account number (no such number)": "Invalid account number.",
        "Invalid security code": "Invalid security code.",
        "Undefined terminal": "Undefined terminal."
    };
} else if ($Language === 'fr') {
    $locationAlert = 'Veuillez choisir le bon emplacement';
    $time = 'Durée prévue: ';
    $length = 'Distance: ';
    $mins = 'min';
    $km = ' KM';
    $choiceCountyCode = 'Veuillez choisir le code du pays';
    $errorEmailMsg = 'Mauvaise adresse email Ã  l\'inscription';
    $pleaseEnterNameMsg = 'S\'il vous plaÃ®t entrez votre nom';
    $pleaseEnterMobileMsg = 'S\'il vous plaÃ®t entrez votre numÃ©ro de tÃ©lÃ©phone';
    $pleaseEnterNumberOnly = 'Phone number must be numbers only';
    $pleaseEnterValidMobileMsg = 'Le numÃ©ro de tÃ©lÃ©phone doit comporter plus de 5 chiffres.';
    $TooManyAttempts = 'Trop de demandes. Veuillez rÃ©essayer aprÃ¨s 60 secondes.';
    $errorSending = 'Une erreur s\'est produite lors de l\'envoi du message. Veuillez réessayer ultérieurement.';
    $forbidden = 'The email field has already been taken';
    $pleaseEnterNameEmail = 'Veuillez saisir le courrier électronique';
    $policyValidation = 'Veuillez accepter les conditions et politiques';
    $pleaseEnterTime = 'Veuillez entrer l\'heure.';
    $pleaseEnterDate = 'Veuillez entrer la date.';
    $pleaseEnterReturnDate = 'Veuillez entrer une date de retour valide';
    $pleaseEnterReturnTime = 'Veuillez entrer une l\'heure de retour valide';
    $daysCount = 'Nombre de jours';
    $pleaseEnterDate = 'Le paiement a été effectué avec succès';
    $pleaseEnterPassportNumber = 'Veuillez entrer le numéro de passeport';
    $please_check_terms_and_conditions = 'Veuillez accepter les termes et conditions';
    $please_enter_cardholdername = 'Veuillez saisir correctement le nom du titulaire de la carte.';
    $please_enter_cardnumber = 'Veuillez saisir correctement le numéro de la carte.';
    $please_enter_expirydate = 'Veuillez saisir correctement la date d\'expiration.';
    $please_enter_cvv = 'Veuillez saisir correctement le code CVV.';
    $please_review_paymentinfo = 'Veuillez vérifier les informations de paiement avant de continuer.';
    $payment_successful = 'Paiement effectué avec succès.';
    $apply = 'Appliquer';
    $cancel = 'Annuler';
    $chair = 'Chaise';
    $bags = 'Sacs';
    $iAgree = 'Je suis d\'accord ';
    $currentLocation = 'Emplacement actuel';
    $chooseDistanceMsg = 'Veuillez choisir une distance supérieure à 1 km';
    $newOrderQuestion = "Voulez-vous annuler la commande et en créer une nouvelle?";
    $monthes = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
    $daysOfWeek = [
        "lu",
        "Ma",
        "mer",
        "jeu",
        "ven",
        "Sa",
        "di"
    ];
    var messagesArray = {
        "Giriş yaptığınız işlem tipi için zorunlu alanları kontrol ediniz": "Veuillez vérifier les champs obligatoires pour le type de transaction auquel vous vous êtes connecté.",
        "Hatali para birimi": "Devise incorrecte.",
        "Aynı sipariş içinde sadece bir tane satış işlemi yapılabilir": "Une seule transaction de vente peut être effectuée pour la même commande.",
        "TxnAmount field must not be zero DOUBLE value because of the Mandatory Rule:zero": "Le champ TxnAmount ne doit pas être une valeur DOUBLE nulle en raison de la règle obligatoire : zéro.",
        "Yurtici kartlar YP islem yapamaz": "Les cartes nationales ne peuvent pas effectuer de transactions YP.",
        "SON KULLANMA TARIHI HATALI": "Date d'expiration invalide.",
        "Sadece şifreli işlem yapılmasına izin verilmektedir": "Seules les transactions cryptées sont autorisées.",
        "YURTICI ALISVERIS LIMITI ASIMI": "Limite d'achat national dépassée.",
        "Giriş yaptığınız değerleri kontrol ediniz": "Veuillez vérifier les valeurs que vous avez saisies.",
        "CardNumber field must contain a valid card number": "Le champ CardNumber doit contenir un numéro de carte valide.",
        "Unidentified Card Number": "Numéro de carte non identifié.",
        "Hesap musait degil.": "Le compte ne dispose pas du montant requis.",
        "Islem Onaylanmadi.": "Transaction non approuvée.",
        "User Gave Up": "L'utilisateur a abandonné la transaction.",
        "CVC2/4CSC HATALI,MAX SAYI ASTI": "CVC2/4CSC est invalide, nombre maximum dépassé.",
        "Vadesi Dolmus Kart.": "Carte expirée.",
        "ISLEM ONAYLANMADI": "Transaction non approuvée.",
        "ECOMMERCE ISLEM LIMITI ASILIYO": "Limite de transaction de commerce électronique dépassée.",
        "SON KULLANMA TARIHI GECMIS": "La carte est expirée.",
        "İşleminizi gerçekleştiremiyoruz.Tekrar deneyiniz": "Nous ne pouvons pas traiter votre transaction. Veuillez réessayer.",
        "ErrorId: 0651": "Erreur : 0651.",
        "ErrorId: 0104": "Erreur : 0104.",
        "ErrorId: 0800": "Erreur : 0800.",
        "ErrorId: 0752": "Erreur : 0752.",
        "ErrorId: 0116": "Erreur : 0116.",
        "Invalid account number (no such number)": "Numéro de compte invalide.",
        "Invalid security code": "Code de sécurité invalide.",
        "Undefined terminal": "Terminal non défini."
    };
}

let passengers_count = 1;

const map = new google.maps.Map(document.getElementById("map"),
    {
        mapTypeControl: false,
        zoom: 12,
    }
);
let inputFromPlace = document.getElementById('fromPlaces');
let inputToPlace = document.getElementById('toPlaces');

const options = {
    componentRestrictions: { country: "tr" },
    fields: ["address_components", "geometry", "place_id", "formatted_address", "name", "url"],
}

let autocompleteFromField = new google.maps.places.Autocomplete(inputFromPlace, options);
let autocompleteToField = new google.maps.places.Autocomplete(inputToPlace, options);

inputFromPlace.focus();

let resultField = document.getElementById('result');
let distanceLength = document.getElementById('distance-length');
let distanceTime = document.getElementById('distance-time');
let resultFieldDuration = document.getElementById('resultDuration');


let directionsService = new google.maps.DirectionsService();

let directionsRenderer = new google.maps.DirectionsRenderer();
directionsRenderer.setMap(map);

function calcRoute() {
    let origin = inputFromPlace.value;
    let destination = inputToPlace.value;

    let request = {
        origin: origin,
        destination: destination,
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.metric
    }

    directionsService.route(request, (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
            distanceLength.value = parseInt(result.routes[0].legs[0].distance.text.replace(',', '')) + ' ' + $km;
            distanceTime.value = Math.ceil(result.routes[0].legs[0].duration.value / 60) + ' ' + $mins;

            directionsRenderer.setDirections(result);
            directionsRenderer.setOptions({ suppressMarkers: true })
        } else {
            directionsRenderer.setDirections({ routes: [] })
            map.setCenter(myLatLng);
        }
    });

    beachFlagImg =
        document.location.origin + "/assets/img/site-options/map-marker.svg";

    new google.maps.Marker({
        position: autocompleteFromField.getPlace().geometry.location.toJSON(),
        map,
        // title: "Hello World!",
        icon: beachFlagImg,
    });
    new google.maps.Marker({
        position: autocompleteToField.getPlace().geometry.location.toJSON(),
        map,
        // title: "Hello World!",
        icon: beachFlagImg,
    });
    directionsRenderer.setOptions({
        polylineOptions: {
            strokeColor: '#4D03FF',
        }
    });
    // Render the route on the map.
    directionsRenderer.setMap(map);
    if (autocompleteFromField.getPlace()) {
        map.setCenter(autocompleteFromField.getPlace().geometry.location.toJSON());
    }
}
function getCurrentLocation() {
    if ("geolocation" in navigator) {
        // Use the Geolocation API to get the user's current location
        navigator.geolocation.getCurrentPosition(function (position) {
            // Extract latitude and longitude from the position object
            var currentLat = position.coords.latitude;
            var currentLng = position.coords.longitude;

            // Set the current location as the origin
            var origin = new google.maps.LatLng(currentLat, currentLng);

            // Get the destination from your input field or any other source
            var destination = autocompleteToField.getPlace() ? autocompleteToField.getPlace().name : origin;

            // Create a request object for route calculation
            var request = {
                origin: origin,
                destination: destination,
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem.metric
            };

            // Call the DirectionsService to calculate the route
            directionsService.route(request, function (result, status) {
                if (status === google.maps.DirectionsStatus.OK) {
                    inputFromPlace.value = result.routes[0].legs[0].start_address;
                    inputFromPlace.focus();
                } else {
                    directionsRenderer.setDirections({ routes: [] });
                }
            });
        }, function (error) {
            // Handle any errors that occur when trying to get the user's location
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    console.error("User denied the request for geolocation.");
                    break;
                case error.POSITION_UNAVAILABLE:
                    console.error("Location information is unavailable.");
                    break;
                case error.TIMEOUT:
                    console.error("The request to get user location timed out.");
                    break;
                case error.UNKNOWN_ERROR:
                    console.error("An unknown error occurred.");
                    break;
            }
        });
    } else {
        console.error("Geolocation is not available in this browser.");
    }
}

$(document).ready(function () {

    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    today = `${yyyy}-${mm}-${dd}`;
    $('#sortCodeSecond').attr('placeholder', yyyy - 2000)
    $('#firsCodeSecond').attr('placeholder', mm)
    $('#sortCodeSecond').on('blur', function () {
        var thisMonth = mm;
        var thisYear = yyyy;
        if (($(this).val() == thisYear && $('#sortCodeFirst').val() < thisMonth) || $(this).val() < thisYear) {
            $(this).addClass('invalid')
            $('#sortCodeFirst').addClass('invalid')
        } else {
            $(this).removeClass('invalid')
            $('#sortCodeFirst').removeClass('invalid')
        }
    })
    $('input').on('keypress keyup', function () {
        if ($(this).hasClass('invalid')) {
            $(this).removeClass('invalid')
        }
    })

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };
    function tConvert(time) {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) { // If time format correct
            time = time.slice(1);  // Remove full string match value
            time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
            time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(''); // return adjusted time or original string
    }
    $('.daterange-select input').daterangepicker({
        "opens": 'right',
        "minDate": today,
        "singleDatePicker": true,
        "autoApply": true,
        locale: {
            format: 'YYYY-MM-DD',
            monthNames: $monthes,
            daysOfWeek: $daysOfWeek
        }
    })
    var dateToOptions = {
        "opens": 'right',
        "minDate": today,
        "singleDatePicker": true,
        "autoApply": true,
        locale: {
            format: 'YYYY-MM-DD',
            monthNames: $monthes,
            daysOfWeek: $daysOfWeek
        }
    }
    $('#date-to').daterangepicker(dateToOptions)
    $('#private_car_pickup_date').daterangepicker({
        "opens": 'right',
        "minDate": today,
        "singleDatePicker": true,
        "autoApply": true,
        locale: {
            format: 'YYYY-MM-DD',
            monthNames: $monthes,
            daysOfWeek: $daysOfWeek

        }
        , function(start, end, label) {
            $('.date-text').html(`${start.format('YYYY-MM-DD')} 
            <svg xmlns="http://www.w3.org/2000/svg" width="67.494" height="10.285" viewBox="0 0 67.494 10.285" style="&#10; ${$Language != 'ar' ? 'rotate: 180deg;&#10;' : 'rotate: 0deg;&#10;'}" data-arp-injected="true">
                <g id="Group_23225" data-name="Group 23225" transform="translate(0 1.061)">
                <g id="Group_23171" data-name="Group 23171" transform="translate(36.597 8.163) rotate(-180)">
                    <path id="Path_31307" data-name="Path 31307" d="M0,0,4.082,4.082,8.163,0" transform="translate(5 8.163) rotate(-90)" fill="none" stroke="#9295D1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                    <path id="Path_31308" data-name="Path 31308" d="M0,7.584V0" transform="translate(0 4.082) rotate(-90)" fill="none" stroke="#9295D1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                </g>
                    <path id="Path_31314" data-name="Path 31314" d="M529.595,429H550.96" transform="translate(-529.595 -424.5)" fill="none" stroke="#9295D1" stroke-width="0.5" stroke-dasharray="4"/>
                    <path id="Path_31315" data-name="Path 31315" d="M529.595,429H553.4" transform="translate(-485.907 -424.5)" fill="none" stroke="#9295D1" stroke-width="0.5" stroke-dasharray="4"/>
                </g>
            </svg>
          `)
        }
    });

    $('#private_car_drop_date').daterangepicker(dateToOptions);

    $('#private_car_pickup_date').on('apply.daterangepicker', function () {
    
        dateToOptions.minDate = $('#private_car_pickup_date').data('daterangepicker').startDate.format('YYYY-MM-DD')
        $('#private_car_drop_date').daterangepicker(dateToOptions);
        $('#private_car_drop_date').attr('disabled', false);
        $('#private_car_drop_date').trigger("focus");

    });

    $('#date-from').on('apply.daterangepicker', function () {
        dateToOptions.minDate = $('#date-from').data('daterangepicker').startDate.format('YYYY-MM-DD')
        $('#date-to').daterangepicker(dateToOptions);
    });
    function addHourTo() {
        var timeFrom = $('#time-from').val();

        // Convert timeFrom to a Date object
        var dateFrom = new Date('1970-01-01T' + timeFrom);

        // Add one hour to the date
        dateFrom.setHours(dateFrom.getHours() + 2);

        // Format the new time to match the input format
        var newTimeTo = dateFrom.toTimeString().slice(0, 5);

        // Set the new time in #time-to input field
        $('#time-to').val(newTimeTo);
    }
    addHourTo();
    $('#time-from , #time-from ,#date-from ,#date-to').on('change', function () {
        if ($('#date-from').val() == $('#date-to').val() && $('#time-from').val() > $('#time-to').val()) {
            addHourTo();
        }
    });

    $('.form-control').on('show.daterangepicker', function () {
        $('.applyBtn').text($apply);
        $('.cancelBtn').text($cancel);
    });
    $("#smartwizard").on("showStep", function (e, anchorObject, currentStepIndex, nextStepIndex, stepDirection) {

        if ($('#transfer-check').is(':checked')) {
            $('.step-2-nav').removeClass('large-map');
        } else {
            $('.step-2-nav').addClass('large-map');
        }

        if (currentStepIndex > 0) {
            if ($(window).width() < 768) {
                $('.page-header').hide(300);
                $('.mobile-nav, .smartwizard-bottom-bar , .show-nav-desktop').show(200);
                $('.mobile-nav, .smartwizard-bottom-bar , .show-nav-desktop').css('display', 'flex')
                $('.progress').show(300);
            }
            $('.back-btn').show(300)
            $('.page-content').addClass('steps-start');
        } else {
            if ($(window).width() < 768) {
                $('.nav-desktop').removeClass('active');
                $('.mobile-nav, .smartwizard-bottom-bar , .show-nav-desktop').hide(300);
                $('.page-header').show(300);
                $('.progress').hide(300);
            }
            $('.back-btn').hide(300)
            $('.page-content').removeClass('steps-start');
        }
    });
    $('.smartwizard-bottom-bar .btn').click(function () {
        let step = $('#smartwizard').smartWizard("getStepInfo").currentStep + 1;
        if (step === 5 && $('#creditCard').hasClass('active')) {
            $('.payment-submit').click()
        } else {

            $(`.step-${$('#smartwizard').smartWizard("getStepInfo").currentStep + 1} .next-step`).trigger('click');
        }
    });
    let transfer_return_check = false;
    $('#transfer-check').on('change', function () {
        if ($('#transfer-check').is(':checked')) {
            $('.date-time-2').show(300);
            $('.trip-info').append($('<div>').addClass('decor'))
            $('.smartwizard-bottom-bar')
            transfer_return_check = true
        } else {
            $('.date-time-2').hide(300);
            $('.decor').remove()
            transfer_return_check = false
        }
    })

    $('#smartwizard').smartWizard({
        autoAdjustHeight: false,
        backButtonSupport: false,
        enableUrlHash: false,
        toolbar: {
            position: 'none',
        },
        keyboard: {
            keyNavigation: false,
        },
        anchor: {
            enableNavigation: true,
        }
    });
    $('.show-nav-desktop').on('click', function () {
        $('.nav-desktop').toggleClass('active');
        $(this).toggleClass('active');
    });
    // google.maps.event.addListener(autocompleteFromField, 'place_changed', function () {
    //     calcRoute()
    // });
    google.maps.event.addListener(autocompleteToField, 'place_changed', function () {
        if (autocompleteFromField.getPlace()) {
            calcRoute()
        }
    });
    $('#toPlaces ,#fromPlaces').on('keyup keypress', function () {
        var airPortFinder = $('#toPlaces').val().toLowerCase() + $('#fromPlaces').val().toLowerCase();
        if (airPortFinder.includes('airport') || airPortFinder.includes('havalimanı') || airPortFinder.includes('مطار')) {
            $('.airplane-ticket').show(300);
        } else {
            $('.airplane-ticket').hide(300);
        }
    })
    $(window).on('load', function () {
        if ($('#smartwizard').smartWizard("getStepInfo").currentStep > 0) {
            $('#smartwizard').smartWizard("goToStep", 0);
        }
    })
    $('.switch-locations').on('click', function () {
        $this = $(this).parents('.places');
        var input1Value = $this.find('#fromPlaces').val();
        var input2Value = $this.find('#toPlaces').val();

        $('#fromPlaces').val(input2Value);
        $('#toPlaces').val(input1Value);
    })
    function fillDataToStep2(orderData) {
        var fromInfo = $('.from-info');
        var toInfo = $('.to-info');
        var distanceInfo = $('.distance-info');
        fromInfo.find('.date').text(orderData.pickup_date);
        fromInfo.find('.location .to').attr('title', orderData.pickup_location)
        fromInfo.find('.location .to').attr('data-toggle', "tooltip")
        fromInfo.find('.location .to').attr('title', orderData.pickup_location)
        fromInfo.find('.location .to').text(orderData.pickup_location);
        fromInfo.find('.location .from').attr('title', orderData.drop_location)
        fromInfo.find('.location .from').attr('data-toggle', "tooltip")
        fromInfo.find('.location .from').text(orderData.drop_location);
        fromInfo.find('.pnr').text(orderData.return_pnr);
        distanceInfo.find('.length .text').text($length)
        distanceInfo.find('.length .no').text(orderData.return_checked ? orderData.distance * 2 : orderData.distance)
        distanceInfo.find('.time .text').text($time)
        distanceInfo.find('.time .no').text(orderData.estimated_time)
        if (orderData.fees != null && orderData.fees) {
            $('.totalPayment').text(orderData.fees + ' $')
        }
        if (orderData.car != null && orderData.car) {
            $('.car-card-wrapper').html(/*html*/`
                <div class="car-card">
                    <div class="image">
                        <img src="${orderData.car.image}" alt="${orderData.car.title}">
                    </div>
                    <div class="content">
                        <div class="options">
                            <h4 class="title">
                                ${orderData.car.title}
                            </h4>
                            <span class="passengers">
                                ${orderData.car.passengers + ' ' + $chair}
                            </span>
                            <span class="bags">
                                ${orderData.car.bags + ' ' + $bags}
                            </span>
                        </div>
                    </div>
                </div>`)
        }
        if ($('#transfer-check').is(":checked")) {
            toInfo.show()
            toInfo.find('.date').text(orderData.drop_date ?? orderData.pickup_date)
            toInfo.find('.location .to').text(orderData.pickup_location)
            toInfo.find('.location .to').attr('title', orderData.drop_location_title)
            toInfo.find('.location .from').text(orderData.drop_location)
            toInfo.find('.location .from').attr('title', orderData.drop_location_title)
            toInfo.find('.pnr').text(orderData.pnr)
        } else {
            toInfo.find('.date').text('')
            toInfo.find('.location .to').attr('title', '')
            toInfo.find('.location .to').text('')
            toInfo.find('.location .from').text('')
            toInfo.find('.location .from').attr('title', '')
            toInfo.find('.pnr').text('')
        }


    }
    function fillPrivateCar(orderData) {
        $('#cars_list').html('');
        var fromInfo = $('.from-info');
        var toInfo = $('.to-info');
        $('.distance-info').hide();
        fromInfo.find('.location *').text('')
        toInfo.find('.location *').text('')
        fromInfo.find('.location .from').attr('title', orderData.tour);
        fromInfo.find('.location .from').text(orderData.tour);
        toInfo.find('.location .to').attr('title', orderData.tour);
        toInfo.find('.location .to').text(orderData.tour);
        $('.day-count').html(/*html*/`<i class="fas fa-calendar-alt"></i> ${$daysCount}: ${orderData.days_count}`)
        var priviteCarInfo = $('.private-car');
        $('.services-list').html('')
        if (orderData.fees != null && orderData.fees) {
            $('.totalPayment').text(orderData.fees + ' $')
        }
        if (orderData.car != null && orderData.car) {
            $('.car-card-wrapper').html(/*html*/`
                <div class="car-card">
                    <div class="image">
                        <img src="${orderData.car.image}" alt="${orderData.car.title}">
                    </div>
                    <div class="content">
                        <div class="options">
                            <h4 class="title">
                                ${orderData.car.title}
                            </h4>
                            <span class="passengers">
                                ${orderData.car.passengers + ' ' + $chair}
                            </span>
                            <span class="bags">
                                ${orderData.car.bags + ' ' + $bags}
                            </span>
                        </div>
                    </div>
                </div>`)
        }
        if ($('[name=childs_seat]').is(':checked')) {
            priviteCarInfo.find('.services-list').html(priviteCarInfo.find('.services-list').html() + /*html*/`<li class="childs_seat"><i class="far fa-dot-circle"></i> ${orderData.child_seat}</li>`)
        } else {
            $('.childs_seat').remove()
        }
        if ($('[name=wheel_chair]').is(':checked')) {
            priviteCarInfo.find('.services-list').html(priviteCarInfo.find('.services-list').html() + /*html*/`<li class="wheel_chair"><i class="far fa-dot-circle"></i> ${orderData.wheel_chair}</li>`)
        } else {
            $('.wheel_chair').remove()
        }
        if ($('.services-list').html().length > 0) {
            $('.services-wrapper .title').show()
        } else {
            $('.services-wrapper .title').hide()
        }
    }

    function regenerateCSRF(selector = null, callableFunction = null, items = null, daysCount = null) {
        $.ajax({
            url: '/csrf', method: 'get', dataType: 'text', async: false, success: function (response) {
                // set new token
                if (JSON.parse(response)) {
                    $('meta[name="csrf-token"]').attr('content', JSON.parse(response).token);
                    $('input[name="_token"]').val(JSON.parse(response).token);
                }
            }
        }).done(function () {

            if (selector != null) {
                $(selector).trigger('click');
            }
            if (callableFunction != null) {
                callableFunction(items, daysCount)
            }
        });

    }

    function selectCar(items, daysCount) {
        $.ajax({
            url: document.location.origin + '/' + $Language + "/orders/select-car", method: 'POST', headers: {
                accept: "application/json"
            }, dataType: 'json', data: {
                country: country,
                type: $('#transfer-tab').hasClass('active') ? 'transfer' : 'private',
                _token: $('meta[name="csrf-token"]').attr('content'),
                car_id: items.car_id,
                order_id: items.order_id,
                distance: items.distance,
                estimated_time: items.estimated_time,
                days_count: daysCount,
            }, beforeSend: function () {
                $('#smartwizard').smartWizard("loader", "show")
                $('form').find('input').attr('disabled', 'true');
                $('form').find('.next-btn').attr('disabled', 'true');
            }, success: function (data) {
                passengers_count = data.car.passengers;
                $('#smartwizard').smartWizard('next');
            }, complete: function () {
                $('#smartwizard').smartWizard("loader", "hide")
                $('form').find('input:disabled').removeAttr('disabled');
                $('form').find('.next-btn:disabled').removeAttr('disabled');
            }, error: function (response) {
                if (response.status === 419) {
                    regenerateCSRF(null, selectCar, items, daysCount)
                }
                $('#smartwizard').smartWizard("loader", "hide")
                $('form').find('input:disabled').removeAttr('disabled');
                $('form').find('.next-btn:disabled').removeAttr('disabled');
            }
        })
        $('input[name=phone]').val($('input[name=phone]').val().replace(/\s/g, ""))
    }
    $('.next-btn').on('click', function (e) {
        e.preventDefault();
        if ($('.car-transfer-tabs #transfer-tab.active').length != 0) {
            var $this = $('.transfer-pane');
            var transferFromPlaces = $this.find('input[name=transfer_from_places]');
            var transferToPlaces = $this.find('input[name=transfer_to_places]');
            var transferToDate = $this.find('input[name=transfer_to_date]');
            var transferToTime = $this.find('input[name=transfer_to_time]');
            var transferFromDate = $this.find('input[name=transfer_from_date]');
            var transferFromTime = $this.find('input[name=transfer_from_time]');

            var valid = true;
            var validMsg = '';
            console.log(transferFromPlaces.val(), transferToPlaces.val())
            if (transferFromPlaces.val() == '') {
                valid = false;
                validMsg = $locationAlert;
                transferFromPlaces.addClass('invalid')
            } else if (transferToPlaces.val() == '') {
                valid = false;
                validMsg = $locationAlert;
                transferToPlaces.addClass('invalid')
            } else if (transferToDate.val() == '') {
                valid = false;
                validMsg = $pleaseEnterDate;
                transferToDate.addClass('invalid')
            } else if (transferToTime.val() == '') {
                valid = false;
                validMsg = $pleaseEnterTime;
                transferToTime.addClass('invalid')
            } else if (transferFromTime.val() > transferToTime.val() && transferFromDate.val() == transferToDate.val()) {
                valid = false;
                validMsg = $pleaseEnterReturnTime;
            } else if (transferFromDate.val() < transferToDate.val()) {
                valid = false;
                validMsg = $locationAlert;
            } else if (parseInt(distanceLength.value) <= 1) {
                valid = false;
                validMsg = $chooseDistanceMsg;
            } if (validMsg != '') {
                iziToast.warning({ message: validMsg });
            } else {
                $.ajax({
                    url: document.location.origin + '/' + $Language + "/orders/calculate-cars-fees",
                    method: 'POST',
                    headers: {
                        accept: "application/json"
                    },
                    contentType: "application/json",
                    dataType: 'json',
                    data: JSON.stringify({
                        country: country,
                        order_id: sessionStorage.getItem('order_id'),
                        type: $('#transfer-tab').hasClass('active') ? 'transfer' : 'private',
                        _token: $('meta[name="csrf-token"]').attr('content'),
                        pickup_location: autocompleteFromField.getPlace().name,
                        pickup_date: transferToDate.data('daterangepicker').startDate.format('YYYY-MM-DD'),
                        pickup_time: transferFromTime.val(),
                        pickup_url: autocompleteFromField.getPlace().url,
                        drop_lat_lng: autocompleteToField.getPlace().geometry.location.lng(),
                        pickup_lat_lng: autocompleteFromField.getPlace().geometry.location.lng(),
                        drop_location: autocompleteToField.getPlace().name,
                        transfer_return_check: $('#transfer-check').is(':checked'),
                        drop_url: autocompleteToField.getPlace().url,
                        drop_date: transfer_return_check ? transferFromDate.data('daterangepicker').startDate.format('YYYY-MM-DD') : null,
                        drop_time: transfer_return_check ? transferToTime.val() : null,
                        message: $this.find('[name=message]').val(),
                        distance: parseFloat(distanceLength.value),
                        pnr: $this.find('[name=transfer_arrival_ticket]').val(),
                        return_pnr: $this.find('[name=transfer_departure_ticket]').val(),
                        pickup_location_coordinates: autocompleteFromField.getPlace().geometry.location.toJSON(),
                        drop_location_coordinates: autocompleteToField.getPlace().geometry.location.toJSON(),
                    }),
                    beforeSend: function () {
                        $('#smartwizard').smartWizard("loader", "show")
                        $('form').find('input').attr('disabled', 'true');
                        $('form').find('.next-btn').attr('disabled', 'true');
                    },
                    success: function (data) {
                        console.log(data)
                        var orderData = {
                            drop_date: $('.date-time #date-from').val() + ' - ' + tConvert($('.date-time #time-from').val()),
                            pickup_date: $('.date-time #date-to').val() + ' - ' + tConvert($('.date-time #time-to').val()),
                            drop_location: autocompleteFromField.getPlace().name,
                            drop_location_title: autocompleteFromField.getPlace().name,
                            pickup_location: autocompleteToField.getPlace().name,
                            pickup_location_title: autocompleteToField.getPlace().name,
                            distance: distanceLength.value,
                            estimated_time: distanceTime.value,
                            pnr: $('.date-time #departure-ticket').val(),
                            return_pnr: $('.date-time #arrival-ticket').val(),

                        }
                        fillDataToStep2(orderData)
                        $('label[for="terms_and_conditions"]').html(/* html */`
                            ${$iAgree}<a target="popup" href='${document.location.origin}/${$Language}/${data.terms_page.slug}'>${data.terms_page.title}</a>
                        `)
                        $('#cars_list').html(data.html);
                        if (sessionStorage.getItem("order_id") == '' || sessionStorage.getItem("order_id") == null) {
                            sessionStorage.setItem("order_id", data.order_id);
                        }
                        let order_id = sessionStorage.getItem("order_id");
                        $('#smartwizard').smartWizard('next');
                        map.setZoom(12)
                        map.setCenter(autocompleteFromField.getPlace().geometry.location.toJSON())
                        $('.book-btn').on('click', function (e) {
                            var originalCarCard = $(this).parents('.car-card');
                            var clonedCarCard = originalCarCard.clone();
                            $('.step-3-nav .car-card-wrapper').html('')
                            $('.step-3-nav .car-card-wrapper').append(clonedCarCard);
                            $.each(data.cars, function (i, item) {
                                if (i == parseInt(originalCarCard.attr('id'))) {
                                    console.log(item);
                                    $('.totalPayment').text(item + ' $');
                                    $('[name=total_amount]').val(item);
                                    let items = {
                                        car_id: i,
                                        order_id: order_id,
                                        distance: parseFloat(distanceLength.value),
                                        estimated_time: parseInt(distanceTime.value.replace($mins, ''))
                                    }
                                    selectCar(items)
                                }
                            });
                        })
                    }, complete: function () {
                        $('#smartwizard').smartWizard("loader", "hide")
                        $('form').find('input:disabled').removeAttr('disabled');
                        $('form').find('.next-btn:disabled').removeAttr('disabled');
                    }, error: function (response) {
                        if (response.status === 419) {
                            regenerateCSRF('.next-btn');
                        }
                        $('#smartwizard').smartWizard("loader", "hide")
                        $('form').find('input:disabled').removeAttr('disabled');
                        $('form').find('.next-btn:disabled').removeAttr('disabled');
                    }
                })
            }
            $('.step-2-nav').removeClass('private-car');
            $('.step-3-nav').removeClass('private-car');
            $('.step-2-nav').addClass('transfer');
        } else {
            // private car form actions 

            let dateValue = [$('[name=private_car_pickup_date]').val(), $('[name=private_car_drop_date]').val()]
console.log(dateValue);
            function datediff(first, second) {
                return Math.round((second - first) / (1000 * 60 * 60 * 24)) + 1;
            }

            function parseDate(str) {
                var mdy = str.split('-');
                return new Date(mdy[0], mdy[1] - 1, mdy[2]);
            }

            var daysCount  = 

         datediff(parseDate(dateValue[0]), parseDate(dateValue[1]))

            var $this = $('.car-transfer-content');

            var privateCarDaterange = $this.find('input[name=private_car_pickup_date]');

            var tour = $this.find('select[name=tour]');

            var valid = true;
            var validMsg = '';
            if (privateCarDaterange.val() == '') {
                valid = false;
                validMsg = $pleaseEnterDate;
                privateCarDaterange.addClass('invalid')
                privateCarDaterange.trigger('focus')
            } else if (tour.val() === '') {
                valid = false;
                validMsg = $locationAlert;
                tour.addClass('invalid')
                tour.trigger('focus')
            }
            if (validMsg != '') {
                iziToast.warning({ message: validMsg });
            } else {
                $.ajax({
                    url: document.location.origin + '/' + $Language + "/orders/calculate-cars-fees",
                    method: 'POST',
                    headers: {
                        accept: "application/json"
                    },
                    contentType: "application/json",
                    data: JSON.stringify({
                        country: country,
                        type: $('#transfer-tab').hasClass('active') ? 'transfer' : 'private',
                        days_count: daysCount,
                        order_id: sessionStorage.getItem("order_id"),
                        pickup_date: $('[name=private_car_pickup_date]').val(),
                        drop_date: $('[name=private_car_drop_date]').val(),
                        tour: tour.val(),
                        wheel_chair: $('[name=wheel_chair]').prop('checked'),
                        child_seat: $('[name=childs_seat]').prop('checked'),
                        _token: $('meta[name="csrf-token"]').attr('content'),
                    }),
                    beforeSend: function () {
                        $('#smartwizard').smartWizard("loader", "show")
                        $('form').find('input').attr('disabled', 'true');
                        $('form').find('.next-btn').attr('disabled', 'true');
                    },
                    success: function (data) {
                        $('.trip-info').append($('<div>').addClass('decor'))
                        $('.step-2-nav').addClass('private-car');
                        $('.step-3-nav').addClass('private-car');
                        $('.step-2-nav').removeClass('transfer');
                        var fromInfo = $('.from-info');
                        var toInfo = $('.to-info');
                        fromInfo.find('.date').text(dateValue[0]);
                        toInfo.find('.date').text(dateValue[1]);
                        toInfo.show()
                        if ($('.decor').length < 0) {
                            $('.trip-info').append($('<div>').addClass('decor'))
                        }
                        var orderData = {
                            tour: $('[name=tour]').find(":selected").text(),
                            wheel_chair: $('[for=wheel_chair]').text(),
                            child_seat: $('[for=childs_seat]').text(),
                            days_count: daysCount,
                        };
                        $('label[for="terms_and_conditions"]').html(/* html */`
                            ${$iAgree} <a target="popup" href='${document.location.origin}/${$Language}/${data.terms_page.slug}'>${data.terms_page.title}</a> 
                        `)
                        fillPrivateCar(orderData);
                        $('#cars_list').html(data.html);
                        $('#smartwizard').smartWizard('next');
                        if (sessionStorage.getItem("order_id") == '' || sessionStorage.getItem("order_id") == null) {
                            sessionStorage.setItem("order_id", data.order_id);
                        }
                        let order_id = sessionStorage.getItem("order_id");
                        $('.book-btn').on('click', function (e) {
                            var originalCarCard = $(this).parents('.car-card');
                            var clonedCarCard = originalCarCard.clone();
                            $('.step-3-nav .car-card-wrapper').html('')
                            $('.step-3-nav .car-card-wrapper').append(clonedCarCard);
                            $.each(data.cars, function (i, item) {

                                if (i == parseInt(originalCarCard.attr('id'))) {
                                    $('.totalPayment').text(item + ' $');
                                    $('[name=total_amount]').val(item);
                                    let items = {
                                        car_id: i,
                                        order_id: order_id,
                                        distance: parseFloat(distanceLength.value),
                                        estimated_time: parseInt(distanceTime.value.replace($mins, ''))
                                    }
                                    selectCar(items, daysCount)
                                }
                            });
                        })
                    },
                    complete: function () {
                        $('#smartwizard').smartWizard("loader", "hide")
                        $('form').find('input:disabled').removeAttr('disabled');
                        $('form').find('.next-btn:disabled').removeAttr('disabled');
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        // Error handler code
                        if (jqXHR.status === 419) {
                            regenerateCSRF('.next-btn')
                        }
                        console.log("Error:", textStatus, errorThrown);
                        $('#smartwizard').smartWizard("loader", "hide")
                        $('form').find('input:disabled').removeAttr('disabled');
                        $('form').find('.next-btn:disabled').removeAttr('disabled');
                    }
                })
            }
        }
    })
    $('.next-contact-form').on('click', function (e) {
        e.preventDefault();
        var $this = $(this).parents('form');
        var name = $this.find('input[name=name]');
        var email = $this.find('input[name=email]');
        var mobile_number = $this.find('input[name=phone]');
        var mobile_number_with_code = $this.find('input[name=phone]').intlTelInput("getNumber");
        var nationality = $this.find('#countrySelect');
        var message = $this.find('input[name=message]');
        $('.passenger_name').val(name.val());
        var emailReg = /^([\w\-\.]{2,}\@[a-zA-Z-0-9]{2,}\.[\w\-]{2,4})/;
        var numReg = /[0-9]/;

        var valid = true;
        var validMsg = '';
        if (name.val() == '') {
            name.addClass('invalid')
            valid = false;
            validMsg = $pleaseEnterNameMsg;
        } else if (mobile_number.val() == '') {
            mobile_number.addClass('invalid')
            valid = false;
            validMsg = $pleaseEnterMobileMsg;
        } else if (!numReg.test(mobile_number.val())) {
            mobile_number.addClass('invalid')
            valid = false;
            validMsg = $pleaseEnterNumberOnly;
        } else if (mobile_number.val().length < 5) {
            mobile_number.addClass('invalid')
            valid = false;
            validMsg = $pleaseEnterValidMobileMsg;
        } else if (email.val() == '') {
            email.removeAttr('value')
            email.addClass('invalid')
            valid = false;
            validMsg = $errorEmailMsg;
        }
        if (validMsg != '') {
            iziToast.warning({ message: validMsg });
        } else {

            $.ajax({
                url: document.location.origin + '/' + $Language + "/orders/car-contact-info",
                method: "POST",
                dataType: "json",
                data: {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                    name: name.val(),
                    phone: mobile_number_with_code,
                    email: email.val(),
                    nationality: nationality.val(),
                    message: message.val(),
                    order_id: sessionStorage.getItem("order_id"),
                },
                beforeSend: function () {
                    $('#smartwizard').smartWizard("loader", "show");
                    $('form').find('input').attr('disabled', 'true');
                    $('form').find('.next-btn').attr('disabled', 'true');
                },
                success: function (data) {
                    $('#smartwizard').smartWizard("next");
                    $('#smartwizard').smartWizard("loader", "hide")
                    $('form').find('input:disabled').removeAttr('disabled');
                    $('form').find('.next-btn:disabled').removeAttr('disabled');
                },
                error: function (data, error_status, error_message) {
                    if (data.status === 419) {
                        regenerateCSRF('.next-contact-form')
                    }
                    $('#smartwizard').smartWizard("loader", "hide")
                    $('form').find('input:disabled').removeAttr('disabled');
                    $('form').find('.next-btn:disabled').removeAttr('disabled');

                }
            });
        }

    })
    $('.next-btn-from-passengers').on('click', function (e) {
        e.preventDefault();
        var $this = $('.passenger-list');
        var passenger_name = $this.find('.passenger_name');
        var passenger_passport = $this.find('.passenger_passport');

        var valid = true;
        var validMsg = '';
        if (passenger_name.val() == '') {
            valid = false;
            validMsg = $pleaseEnterNameMsg;
            passenger_name.addClass('invalid');
        } else if (passenger_passport.val() == '') {
            valid = false;
            validMsg = $pleaseEnterPassportNumber;
            passenger_passport.addClass('invalid');
        }
        if (validMsg != '') {
            iziToast.warning({ message: validMsg });
        } else {

            $('[name=order_id]').val(sessionStorage.getItem('order_id'));
            $.ajax({
                url: document.location.origin + '/' + $Language + "/orders/select-passengers",
                method: "POST",
                dataType: "json",
                data: $('.passengers-form').serialize(),
                beforeSend: function () {
                    $('#smartwizard').smartWizard("loader", "show");
                    $('form').find('input').attr('disabled', 'true');
                    $('form').find('.next-btn').attr('disabled', 'true');
                },
                success: function (data) {
                    $('#smartwizard').smartWizard("next");
                    $('#smartwizard').smartWizard("loader", "hide")
                    $('form').find('input:disabled').removeAttr('disabled');
                    $('form').find('.next-btn:disabled').removeAttr('disabled');
                    $('input[name="order_id"]').val(sessionStorage.getItem('order_id'));
                },
                error: function (response, error_status, error_message) {
                    if (response.status === 419) {
                        regenerateCSRF('.next-btn-from-passengers')
                    }
                    $('#smartwizard').smartWizard("loader", "hide")
                    $('form').find('input:disabled').removeAttr('disabled');
                    $('form').find('.next-btn:disabled').removeAttr('disabled');
                    iziToast.error({ message: response.responseJSON.message });
                }
            })
        }
    })
    $('.payment-submit').on('click', function (e) {
        e.preventDefault()
        var $this = $(this).parents('form');
        var card_holder_name = $this.find('input[name=card_holder_name]');
        var card_number = $this.find('input[name=card_number]');
        var card_number_formated = $this.find('input[name=card_number]').val().replaceAll(' ', '');
        var expire_month = $this.find('input[name=expire_month]');
        var expire_year = $this.find('input[name=expire_year]');
        var cvv_code = $this.find('input[name=cvv_code]');
        var terms_and_conditions = $('input[name=terms_and_conditions]');
        var is_3dsecure = $('[name="is_3dsecure"]')
        var valid = true;
        var validMsg = '';
        if (card_holder_name.val() == '') {
            valid = false;
            validMsg = $please_enter_cardholdername;
            card_holder_name.trigger('focus').addClass('invalid');
        } else if (card_number.val() == '') {
            valid = false;
            validMsg = $please_enter_cardnumber;
            card_number.addClass('invalid').trigger('focus');
        } else if (card_number_formated.length < 15) {
            valid = false;
            validMsg = $please_enter_cardnumber;
            card_number.addClass('invalid').trigger('focus');
        } else if (expire_month.val() == '' || expire_month.val() == 0 || expire_month.val().length < 2 || expire_month.val() > 12) {
            valid = false;
            validMsg = $please_enter_expirydate;
            expire_month.addClass('invalid').trigger('focus');
        } else if (expire_year.val() == '') {
            valid = false;
            validMsg = $please_enter_expirydate;
            expire_year.addClass('invalid').trigger('focus');
        } else if (expire_year.val() < yyyy.toString().slice(2)) {
            valid = false;
            validMsg = $please_enter_expirydate;
            expire_year.addClass('invalid').trigger('focus');
        } else if (cvv_code.val() == '') {
            valid = false;
            validMsg = $please_enter_cvv;
            cvv_code.addClass('invalid').trigger('focus');
        } else if (!(terms_and_conditions[0].checked)) {
            valid = false;
            validMsg = $please_check_terms_and_conditions;
            terms_and_conditions.addClass('invalid').trigger('focus');
        }
        if (validMsg != '') {
            iziToast.warning({ message: validMsg });
        } else {
            if (!is_3dsecure.is(":checked")) {
                $.ajax({
                    url: $this.attr('action'),
                    method: 'POST',
                    dataType: 'json',
                    data: {
                        _token: $('meta[name="csrf-token"]').attr('content'),
                        order_id: sessionStorage.getItem("order_id"),
                        card_holder_name: card_holder_name.val(),
                        card_number: card_number_formated,
                        expire_month: expire_month.val(),
                        expire_year: expire_year.val(),
                        cvv_code: cvv_code.val(),
                    },
                    beforeSend: function () {
                        $('#smartwizard').smartWizard("loader", "show");
                        $('form').find('input').attr('disabled', 'true');
                        $('form').find('.next-btn').attr('disabled', 'true');
                    },
                    success: function (data) {
                        if (data.Transaction.Response.ErrorMsg) {
                            iziToast.warning({
                                message: messagesArray[data.Transaction.Response.ErrorMsg] ?? " "
                            })
                            iziToast.warning({
                                message: messagesArray[data.Transaction.Response.SysErrMsg] ?? ""
                            })                        }
                        else {
                            $('#smartwizard').smartWizard("unsetState", [5], "disable");
                            $('#smartwizard').smartWizard('next');

                            iziToast.success({ message: $payment_successful })

                        }


                    },
                    complete: function () {
                        $('#smartwizard').smartWizard("loader", "hide")
                        $('form').find('input:disabled').removeAttr('disabled');
                        $('form').find('.next-btn:disabled').removeAttr('disabled');
                    },
                    error: function (xhr) {
                        if (xhr.status === 419) {
                            regenerateCSRF('.payment-submit');
                        }
                        iziToast.error({ message: xhr.statusCode });
                    }
                })
            } else {
                $this.submit();
                $('#smartwizard').smartWizard("loader", "show");
            }
        }
    })
    $('.new-order-btn').on('click', function () {
        sessionStorage.removeItem('order_id');
        document.location = document.location.origin + document.location.pathname
    })
    $('.advisor-submit').on('click', function (e) {
        e.preventDefault();
        $this = $(this).parents('form');
        var terms_and_conditions = $('input[name=terms_and_conditions]');

        var valid = true;

        var validMsg = '';
        if (!(terms_and_conditions[0].checked)) {
            valid = false;
            validMsg = $please_check_terms_and_conditions;
            terms_and_conditions.addClass('invalid').trigger('focus');
        }
        if (validMsg != '') {
            iziToast.warning({ message: validMsg });
        } else {
            $.ajax({
                url: document.location.origin + '/' + $Language + '/orders/reserve',
                type: 'POST',
                data: {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                    order_id: sessionStorage.getItem("order_id"),
                },
                beforeSend: function () {
                    $('#smartwizard').smartWizard("loader", "show");
                    $('.advisor-submit').attr('disabled', 'true');
                },
                success: function (message, data) {
                    $('#smartwizard').smartWizard("next");
                    $('a.file-download').attr('href', document.location.origin + '/' + $Language + '/orders/download-receipt/web/' + message.reservation_no);
                    $('.send-mail').attr('data-reservation-no', message.reservation_no);
                    sessionStorage.removeItem('order_id');
                    $('#smartwizard').smartWizard("setState", [0], "disable");
                    $('#smartwizard').smartWizard("setState", [1], "disable");
                    $('#smartwizard').smartWizard("setState", [2], "disable");
                    $('#smartwizard').smartWizard("setState", [3], "disable");
                    $('#smartwizard').smartWizard("setState", [4], "disable");
                    $('.back-btn').hide();
                    $('#smartwizard').smartWizard("loader", "hide");
                    $('.advisor-submit').removeAttr('disabled');
                    $('.reservation-number .number').text(message.reservation_no);
                },
                error: function (xhr, textStatus, errorThrown) {
                    $('.advisor-submit').removeAttr('disabled');
                    if (xhr.status === 419) {
                        regenerateCSRF('.advisor-submit')
                    }
                    $('#smartwizard').smartWizard("loader", "hide");
                    iziToast.error({ message: response.responseJSON.message });
                }
            })
        }
    })
    $('.back-btn').on('click', function (e) {
        e.preventDefault()
        $('#smartwizard').smartWizard("prev");
    })
    // setTimeout(() => {
    //     $('.date-text').html(`${$('#private_car_daterange').data('daterangepicker').startDate.format('DD/MM/YYYY')}
    //         <svg xmlns="http://www.w3.org/2000/svg" width="67.494" height="10.285" viewBox="0 0 67.494 10.285" style="&#10; ${$Language != 'ar' ? 'rotate: 180deg;&#10;' : 'rotate: 0deg;&#10;'}" data-arp-injected="true">
    //             <g id="Group_23225" data-name="Group 23225" transform="translate(0 1.061)">
    //             <g id="Group_23171" data-name="Group 23171" transform="translate(36.597 8.163) rotate(-180)">
    //                 <path id="Path_31307" data-name="Path 31307" d="M0,0,4.082,4.082,8.163,0" transform="translate(5 8.163) rotate(-90)" fill="none" stroke="#9295D1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
    //                 <path id="Path_31308" data-name="Path 31308" d="M0,7.584V0" transform="translate(0 4.082) rotate(-90)" fill="none" stroke="#9295D1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
    //             </g>
    //                 <path id="Path_31314" data-name="Path 31314" d="M529.595,429H550.96" transform="translate(-529.595 -424.5)" fill="none" stroke="#9295D1" stroke-width="0.5" stroke-dasharray="4"/>
    //                 <path id="Path_31315" data-name="Path 31315" d="M529.595,429H553.4" transform="translate(-485.907 -424.5)" fill="none" stroke="#9295D1" stroke-width="0.5" stroke-dasharray="4"/>
    //             </g>
    //         </svg>
    //       ${$('#private_car_daterange').data('daterangepicker').endDate.format('DD/MM/YYYY')}`)
    // }, 300);
    var tomorrow = moment().add(1, 'days');
    // $('#private_car_daterange').daterangepicker({
    //     'direction': 'rtl',
    //     'opens': 'right',
    //     'startDate': today,
    //     'endDate': today,
    //     'minDate': today,
    //     'autoApply': true,
    //     'linkedCalendars': true,
    //     locale: {
    //         format: 'DD/MM/YYYY',
    //         "monthNames": $monthes,
    //         "daysOfWeek": $daysOfWeek
    //     }
    // }, function (start, end, label) {
    //     $('.date-text').html(`${start.format('DD/MM/YYYY')} 
    //     <svg xmlns="http://www.w3.org/2000/svg" width="67.494" height="10.285" viewBox="0 0 67.494 10.285" style="&#10; ${$Language != 'ar' ? 'rotate: 180deg;&#10;' : 'rotate: 0deg;&#10;'}" data-arp-injected="true">
    //         <g id="Group_23225" data-name="Group 23225" transform="translate(0 1.061)">
    //         <g id="Group_23171" data-name="Group 23171" transform="translate(36.597 8.163) rotate(-180)">
    //             <path id="Path_31307" data-name="Path 31307" d="M0,0,4.082,4.082,8.163,0" transform="translate(5 8.163) rotate(-90)" fill="none" stroke="#9295D1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
    //             <path id="Path_31308" data-name="Path 31308" d="M0,7.584V0" transform="translate(0 4.082) rotate(-90)" fill="none" stroke="#9295D1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
    //         </g>
    //             <path id="Path_31314" data-name="Path 31314" d="M529.595,429H550.96" transform="translate(-529.595 -424.5)" fill="none" stroke="#9295D1" stroke-width="0.5" stroke-dasharray="4"/>
    //             <path id="Path_31315" data-name="Path 31315" d="M529.595,429H553.4" transform="translate(-485.907 -424.5)" fill="none" stroke="#9295D1" stroke-width="0.5" stroke-dasharray="4"/>
    //         </g>
    //     </svg>
    //   ${end.format('DD/MM/YYYY')}`)
    // }
    // );

    if ($Language === 'ar') {
        console.log($Language);

        let leftCalendar = $('.daterangepicker .drp-calendar.left:not(.single)');

        leftCalendar.parent().append(leftCalendar);

        let calenders = $('.daterangepicker .drp-calendar').css('direction', 'rtl');
    
    }

    $.ajax({
        url: `${document.location.origin}/landing-assets/vip/js/countries.json`,
        method: 'GET',
        success: function (response) {
            var countryName = response[0].name
            if ($Language == 'ar') {
                countryName = response[0].translations.ara.officialf
            } else if ($Language == 'fr') {
                countryName = response[0].translations.fra.official
            }
            var options = `<option value="" disabled selected>${$('select.countrySelect').data('placeholder')}</option>`;
            var countryCodeOptions = '';
            response.forEach(function (country) {
                var tokens = country.translations.ara.common + ' ' + country.translations.fra.common + ' ' + country.name.official;
                var countryName = country.name
                if ($Language == 'ar') {
                    countryName = country.translations.ara.official
                } else if ($Language == 'fr') {
                    countryName = country.translations.fra.official
                }
                options += '<option id="' + country.cca2 + '" data-tokens="' + tokens + '" value="' + countryName + '">' + countryName + '</option>';
            });
            $('select.countrySelect').append(options);
            $('select.countrySelect').selectpicker('refresh');

        },
        error: function (xhr, status, error) {
            console.error(error);
        }
    });

    $('.add-passenger-btn').on('click', function (e) {
        e.preventDefault();
        var originalElement = $('.passenger-row').last();
        if ($('.passenger-list .passenger-row').length >= passengers_count) {
            return 0
        }
        var clonedElement = originalElement.clone();

        $('.passenger-list').append(clonedElement);
        $('.passenger-row').last().show(300).css({ display: 'flex' })
        $('.passenger-row').last().find('input').val('');
        $('.passenger-row').last().find('.passenger_name').attr('name', $('.passenger-row').first().find('.passenger_name').attr('name').replace('0', $('.passenger-row').length - 1))
        $('.passenger-row').last().find('.passenger_passport').attr('name', $('.passenger-row').first().find('.passenger_passport').attr('name').replace('0', $('.passenger-row').length - 1))
        $('.remove-row').on('click', function (e) {
            e.preventDefault();
            $('.add-passenger-btn').show(300);
            $(this).closest('.passenger-row').hide(300)
            setTimeout(() => {
                $(this).closest('.passenger-row').remove()
            }, 300);
        });

        if ($('.passenger-list .passenger-row').length >= passengers_count) {
            $('.add-passenger-btn').hide(300);
            return 0
        }

    });
    var cardNumberInput = $('#cardNumberInput')
    cardNumberInput.on('keyup', function () {
        $(this).val($(this).val().replace(/[^0-9\s]/g, ''))
        if ($(this).val().length >= 2 && $(this).val().length <= 20) {
            cardNumberInput.validateCreditCard(function (result) {
                if (result.card_type.name == 'maestro' || result.card_type.name == 'mastercard') {
                    $('.credit-card-icon').attr('srcset', `${document.location.origin}/assets/img/criditCardIcons/${result.card_type.name}-alt.svg`)
                } else {
                    $('.credit-card-icon').attr('srcset', `${document.location.origin}/assets/img/criditCardIcons/${result.card_type.name}.svg`)
                }
            })
        } else {
            $('.credit-card-icon').removeAttr('srcset')
        }
    });
    $('.mobile-nav .nav-link').each(function (i) {
        $(this).on('click', function (e) {
            if ($(this).hasClass('done')) {
                $('#smartwizard').smartWizard("goToStep", i);
            }
        });
    });
    const testimonialsCards = new Swiper('.testimonialsCards', {
        slidesPerView: "auto",
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        breakpoints: {
            0: {
                spaceBetween: 10,
            },
            992: {
                spaceBetween: 20,
            }
        },
        pagination: false,
    });
    const carsCarousel = new Swiper('.cars-carousel', {
        breakpoints: {
            0: {
                spaceBetween: 20,
                slidesPerView: 1,
            },
            991: {
                slidesPerView: 3,
                spaceBetween: 108,
                navigation: {
                    nextEl: '.cars-carousel-next',
                    prevEl: '.cars-carousel-prev',
                },
            },
        },

    });
    if ($('.overview-inner-content').height() <= 285) {
        $('.readMore').on('click', function () {
            $('.overview-inner-content').toggleClass('show-more')
            $('.readMore').toggleClass('show-more')
        })
    } else {
        $('.readMore').css('display', 'none')
    }
    $('.send-mail').on('click', function () {
        var reservationNo = $(this).attr('data-reservation-no');
        $.ajax({
            url: $(this).attr('data-url'),
            method: 'POST',
            data: {
                _token: $('meta[name="csrf-token"]').attr('content'),
                reservation_no: reservationNo,
                data_source: 'web',
            },
            beforeSend: function () {
                $('#smartwizard').smartWizard("loader", "show")
            },
            success: function (data) {
                $('#smartwizard').smartWizard("loader", "hide");
                iziToast.success({ message: data.message });
            },
            error: function (xhr, status, error) {
                if (xhr.status === 419) {
                    regenerateCSRF('.send-mail');
                }
                $('#smartwizard').smartWizard("loader", "hide")
                iziToast.error({ message: error });
                console.error(error);
            }
        });
    })
    function getOrder() {
        var savedOrderId = sessionStorage.getItem('order_id') != null ? sessionStorage.getItem('order_id') : getUrlParameter('order_id')
        if (savedOrderId != null && savedOrderId != false) {
            $('input[name="order_id"]').val(savedOrderId);
            function newOrderTriger() {
                $('.back-btn').click(function () {
                    $("#newOrderModal").modal('show');
                })
            }
            $.ajax({
                url: document.location.origin + '/' + $Language + '/orders/details/' + savedOrderId,
                method: 'GET',
                beforeSend: function () {
                    $('#smartwizard').smartWizard("loader", "show")
                },
                success: function (data) {
                    $('label[for="terms_and_conditions"]').html(/* html */`
                            ${$iAgree}<a target="popup" href='${document.location.origin}/${$Language}/${data.page.slug}'>${data.page.title}</a>
                        `)
                    data.message != null ?? iziToast.success(data.message);
                    $('#smartwizard').smartWizard("loader", "hide")
                    if (data.status == 'pending') {
                        $('a.file-download').attr('href', document.location.origin + '/' + $Language + '/orders/download-receipt/web/' + data.reservation_no);
                        newOrderTriger()
                        $('#smartwizard').smartWizard("setState", [0], "disable");
                        $('#smartwizard').smartWizard("setState", [1], "disable");
                        $('#smartwizard').smartWizard("setState", [2], "disable");
                        $('#smartwizard').smartWizard("setState", [3], "disable");
                        $('#smartwizard').smartWizard("goToStep", 4);
                        sessionStorage.setItem('order_id', savedOrderId, true);
                    } else if (data.status == 'approved') {
                        $('a.file-download').attr('href', document.location.origin + '/' + $Language + '/orders/download-receipt/web/' + data.reservation_no);
                        $('#smartwizard').smartWizard("setState", [0], "disable");
                        $('#smartwizard').smartWizard("setState", [1], "disable");
                        $('#smartwizard').smartWizard("setState", [2], "disable");
                        $('#smartwizard').smartWizard("setState", [3], "disable");
                        $('#smartwizard').smartWizard("setState", [4], "disable");
                        $('#smartwizard').smartWizard("goToStep", 5);
                        $('.reservation-number .number').text(data.reservation_no);
                    } else if (data.status == 'cancelled') {
                    }
                    if ((data.type === 'transfer') && (data.status !== 'cancelled') && (['approved', 'pending'].includes(data.status))) {
                        data.estimated_time = data.estimated_time + $mins
                        data.distance = data.distance + $km
                        orderData = data;

                        if (!data.return_checked) {
                            $('.trip-info').append($('<div>').addClass('decor'));
                            $('#transfer-check').attr('checked', 'checked');
                        }

                        newOrderTriger()
                        fillDataToStep2(orderData);
                    }

                    if ((data.type === 'private') && (['approved', 'pending'].includes(data.status))) {
                        orderData = data;

                        if (!data.return_checked) {
                            $('#transfer-check').attr('checked', 'checked');
                        }

                        $('.step-3-nav').addClass('private-car');
                        newOrderTriger();
                        fillPrivateCar(orderData);
                    }
                },
                error: function (xhr, status, error) {
                    $('#smartwizard').smartWizard("loader", "hide")
                    console.error(error);
                }
            })
        }
    }

    getOrder();
})

var cardNumberInput = document.querySelector('#cardNumberInput')
cardNumberInput.addEventListener('input', function (event) {
    var pos = this.selectionStart,
        val = this.value,
        spc = (val.substr(0, pos).match(/\s/g) || []).length,
        num = val.replace(/\s/g, ''),
        len = num.length,
        prv = this.prev != null ? this.prev : '',
        ins = prv != this.value,
        pad = Math.floor(len / 4),
        nex = '';

    if (ins) {
        for (var i = 0; i <= pad; i++)
            nex += num.substr(i * 4, 4) + (pad == 0 || pad == i ? '' : ' ');

        this.value = nex + num.substr(i * 4 + 4);

        var prevSpc = (val.substr(0, pos).match(/\s/g) || []).length,
            currSpc = (this.value.substr(0, pos).match(/\s/g) || []).length,
            newPos = pos + (currSpc - prevSpc);

        this.setSelectionRange(newPos, newPos);
    }

    this.prev = this.value;
});
function onClassChange(element, callback) {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'class'
            ) {
                callback(mutation.target);
            }
        });
    });

    observer.observe(element, { attributes: true });
    return observer.disconnect;
}



document.querySelectorAll('.step-nav').forEach(element => {
    var itemToWatch = element;
    onClassChange(itemToWatch, (node) => {
        var elementIndex = node.getAttribute("data-i")
        if (node.classList.contains('active')) {
            $(`.mobile-nav .nav-link`).removeClass('active');
            $(`.mobile-nav .nav-link:nth(${elementIndex - 1})`).addClass('active');
        }
        if (node.classList.contains('done')) {
            $(`.mobile-nav .nav-link:nth(${elementIndex - 1})`).addClass('done');
        }
        if (node.classList.contains('disabled')) {
            $(`.mobile-nav .nav-link:nth(${elementIndex - 1})`).addClass('dis');
            $(`.mobile-nav .nav-link:nth(${elementIndex - 1})`).on('click', function () {
                $('#newOrderModal').modal('show')
            })
        }
    });
});
function isInViewport(element) {
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return (elementBottom > viewportTop && elementTop < viewportBottom);
}
$(document).scroll(function () {
    var element = $('.application-steps .items');
    if (isInViewport(element)) {
        element.addClass('active');
    } else {
        element.removeClass('active');
    }
    var element = $('.cars-view-wrapper .header');
    if (isInViewport(element)) {
        $('.cars-view-wrapper').addClass('active');
    } else {
        $('.cars-view-wrapper').removeClass('active');
    }
    var element = $('.application-services');
    if (isInViewport(element)) {
        element.addClass('active');
    } else {
        element.removeClass('active');
    }
    var element = $('.numbers');
    if (isInViewport(element)) {
        element.addClass('active');
    } else {
        element.removeClass('active');
    }
});
